<template>
  <div>
    <!-- Media -->
    <b-media class="mb-2">
      <template #aside>
        <b-avatar ref="previewEl" :src="userData.photo" :text="avatarText(userData.fullName)"
          :variant="`light-${resolveUserRoleVariant(userData.fullname)}`" size="90px" rounded />
      </template>
      <h4 class="mb-1">
        {{ userData.fullname }}
      </h4>
      <div class="d-flex flex-wrap">
      </div>
    </b-media>

    <!-- User Info: Input Fields -->
    <b-form>
      <b-row>
        <!-- Field: Username -->

        <!-- Field: Full Name -->
        <b-col cols="12" md="4">
          <b-form-group :label="$t('Name')" label-for="full-name">
            <b-form-input id="full-name" v-model="userData.fullname" />
          </b-form-group>
        </b-col>

        <!-- Field: Email -->
        <b-col cols="12" md="4">
          <b-form-group :label="$t('Email')" label-for="email">
            <b-form-input id="email" v-model="userData.email"/>
          </b-form-group>
        </b-col>

        <!-- Field: Status -->
        <b-col cols="12" md="4">
          <b-form-group :label="$t('Status')" label-for="user-status">
            <v-select v-model="userData.status" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="statusOptions" :reduce="(val) => val.value" :clearable="false" input-id="user-status" />
          </b-form-group>
        </b-col>


        <b-col cols="12" md="4">
          <b-form-group :label="$t('Department')" label-for="user-role">
            <department-picker :initialCategories="parsedInfo" @selectionChanged="valueChanged">
            </department-picker>
          </b-form-group>
        </b-col>


      </b-row>
    </b-form>

    <!-- Action Buttons -->
    <b-button variant="primary" class="mb-1 mb-sm-0 mr-0 mr-sm-1"
      :block="$store.getters['app/currentBreakPoint'] === 'xs'" @click="updateUser">
      {{ $t('Save Changes') }}
    </b-button>
    <!--    
    <b-button
      variant="outline-secondary"
      type="reset"
      :block="$store.getters['app/currentBreakPoint'] === 'xs'"
    >
      Reset Password
    </b-button>
    -->
  </div>
</template>

<script>
import {
  BButton,
  BMedia,
  BAvatar,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BTable,
  BCard,
  BCardHeader,
  BCardTitle,
  BFormCheckbox,
} from "bootstrap-vue";
import { avatarText } from "@core/utils/filter";
import vSelect from "vue-select";
import { useInputImageRenderer } from "@core/comp-functions/forms/form-utils";
import { ref, toRefs } from "@vue/composition-api";
import store from "@/store";
import ToastificationContent from "@/@core/components/toastification/ToastificationContent.vue";
import DepartmentPicker from "@/views/clinic/clinicdepartments/component/DepartmentPicker.vue";
import useUsersList from "../users-list/useUsersList";
import { useToast } from "vue-toastification/composition";
export default {
  components: {
    BButton,
    BMedia,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BTable,
    BCard,
    BCardHeader,
    BCardTitle,
    BFormCheckbox,
    vSelect,
    DepartmentPicker,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const toast = useToast();
    const { userData } = toRefs(props);
    let parsedInfo = null;
    try {
      parsedInfo = JSON.parse(userData.value.info);
      parsedInfo = {
        id: parsedInfo.DEPARTMENTID ?? null,
        name: parsedInfo.DEPARTMENT ?? null,
      };
      userData.value.additionalInfo = parsedInfo;
    } catch (error) {
      console.error("Geçersiz JSON:", error);
    }

    const { resolveUserRoleVariant } = useUsersList();

    const roleOptions = [
      { label: "Admin", value: "admin" },
      { label: "Author", value: "author" },
      { label: "Editor", value: "editor" },
      { label: "Maintainer", value: "maintainer" },
      { label: "Subscriber", value: "subscriber" },
    ];

    const statusOptions = [
      { label: "Active", value: 1 },
      { label: "Inactive", value: 0 },
    ];

    const permissionsData = [
      {
        module: "Admin",
        read: true,
        write: false,
        create: false,
        delete: false,
      },
      {
        module: "Staff",
        read: false,
        write: true,
        create: false,
        delete: false,
      },
      {
        module: "Author",
        read: true,
        write: false,
        create: true,
        delete: false,
      },
      {
        module: "Contributor",
        read: false,
        write: false,
        create: false,
        delete: false,
      },
      {
        module: "User",
        read: false,
        write: false,
        create: false,
        delete: true,
      },
    ];

    // ? Demo Purpose => Update image on click of update
    const refInputEl = ref(null);
    const previewEl = ref(null);

    const { inputImageRenderer } = useInputImageRenderer(
      refInputEl,
      (base64) => {
        // eslint-disable-next-line no-param-reassign
        props.userData.avatar = base64;
      }
    );
    const valueChanged = (payload) => {    
       userData.value.additionalInfo.DEPARTMENT = payload.name;
       userData.value.additionalInfo.DEPARTMENTID = payload.id;
    };
    function updateUser() {
      store
        .dispatch("app-user/updateUser", userData.value)
        .then(() => {
          toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: `Changes successfully applied`,
              icon: "CoffeeIcon",
              variant: "success",
            },
          });
        })
        .catch((e) => {
          toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: `Something went wrong`,
              icon: "CoffeeIcon",
              variant: "danger",
            },
          });
        });
    }

    return {
      updateUser,
      resolveUserRoleVariant,
      avatarText,
      roleOptions,
      statusOptions,
      permissionsData,
      valueChanged,
      //  ? Demo - Update Image on click of update button
      refInputEl,
      previewEl,
      inputImageRenderer,
      parsedInfo,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
